/*environment-variables-in-tasks*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "系统环境变量",
  "description": "了解 Turborepo 使用的系统变量。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "通过设置某些环境变量，你可以更改 Turborepo 的行为。这对于为不同的环境和机器创建特定的配置非常有用。"
  }, {
    "heading": "",
    "content": "¥By setting certain environment variables, you can change Turborepo's behavior. This can be useful for creating specific configurations for different environments and machines."
  }, {
    "heading": "",
    "content": "系统环境变量始终会被直接提供给 turbo 命令的标志值覆盖。"
  }, {
    "heading": "",
    "content": "¥System environment variables are always overridden by flag values provided directly to your turbo commands."
  }, {
    "heading": "",
    "content": "Set the base URL for' '\nRemote Cache."
  }, {
    "heading": "",
    "content": "Manually set the path to the turbo binary. By default,' '\nturbo will automatically discover the binary so you should\nonly use this in rare circumstances."
  }, {
    "heading": "",
    "content": "Control reading and writing for cache sources. Uses the same syntax as' '"
  }, {
    "heading": "",
    "content": "."
  }, {
    "heading": "",
    "content": "Sets the cache directory, similar to using' '"
  }, {
    "heading": "",
    "content": "flag."
  }, {
    "heading": "",
    "content": "Set a prefix for environment variables that you want\nexcluded from \nFramework Inference\n.\nNOTE: This does not need to be set by the user and should\nbe configured automatically by supported platforms."
  }, {
    "heading": "",
    "content": "Disable checking the packageManager field in' '\npackage.json. You may run into' '"
  }, {
    "heading": "",
    "content": "errors and unexpected caching behavior"
  }, {
    "heading": "",
    "content": "when disabling this check. Use true or 1 to\ndisable."
  }, {
    "heading": "",
    "content": "Enables global turbo to install the correct local version\nif one is not found."
  }, {
    "heading": "",
    "content": "Set to true to force all tasks to run in full, opting out\nof all caching."
  }, {
    "heading": "",
    "content": "Disable warning when global turbo cannot find a local\nversion to use."
  }, {
    "heading": "",
    "content": "Disable printing the version of turbo that is being\nexecuted."
  }, {
    "heading": "",
    "content": "Set the log order.\nAllowed values are grouped and default."
  }, {
    "heading": "",
    "content": "Set the URL used to log in to' '\nRemote Cache. Only\nneeded for self-hosted Remote Caches that implement an endpoint that\ndynamically creates tokens."
  }, {
    "heading": "",
    "content": "Remove the update notifier that appears when a new version of' '\nturbo is available. You can also use' '\nNO_UPDATE_NOTIFIER per ecosystem convention."
  }, {
    "heading": "",
    "content": "A CSV of environment variable keys that are configured in a supported CI\nenvironment (Vercel). NOTE: This variable is meant for\nplatforms looking to implement zero-configuration environment variables.\nYou are not meant to use this variable as an end user.' '"
  }, {
    "heading": "",
    "content": "Disable checking environment variables configured in your' '\nturbo.json against those set on your supported platform"
  }, {
    "heading": "",
    "content": "Enables sending a preflight request before every cache artifact and\nanalytics request. The follow-up upload and download will follow\nredirects. Only applicable when' '\nRemote Caching is\nconfigured."
  }, {
    "heading": "",
    "content": "Prevent writing to the' '\nRemote Cache - but\nstill allow reading."
  }, {
    "heading": "",
    "content": "Sign artifacts with a secret key. For more information, visit' '"
  }, {
    "heading": "",
    "content": "the Artifact Integrity section"
  }, {
    "heading": "",
    "content": "."
  }, {
    "heading": "",
    "content": "Set a timeout in seconds for turbo to get artifacts from' '\nRemote Cache."
  }, {
    "heading": "",
    "content": "Set a timeout in seconds for turbo to upload artifacts to' '\nRemote Cache."
  }, {
    "heading": "",
    "content": "Generate a Run Summary' '\nwhen you run tasks."
  }, {
    "heading": "",
    "content": "Base used by --affected when calculating what has changed\nfrom base...head"
  }, {
    "heading": "",
    "content": "Head used by --affected when calculating what has changed\nfrom base...head"
  }, {
    "heading": "",
    "content": "The account name associated with your repository. When using' '"
  }, {
    "heading": "",
    "content": "Vercel Remote Cache"
  }, {
    "heading": "",
    "content": ", this is your team's slug."
  }, {
    "heading": "",
    "content": "The account identifier associated with your repository. When using' '"
  }, {
    "heading": "",
    "content": "Vercel Remote Cache"
  }, {
    "heading": "",
    "content": ", this is your team's ID."
  }, {
    "heading": "",
    "content": "Disable the message notifying you that' '\nTelemetry is enabled."
  }, {
    "heading": "",
    "content": "The Bearer token for authentication to access' '\nRemote Cache."
  }, {
    "heading": "",
    "content": "Enables TUI when passed true or 1, disables when passed false or 0."
  }, {
    "heading": "",
    "content": "Controls' '"
  }, {
    "heading": "",
    "content": "concurrency"
  }, {
    "heading": "",
    "content": "settings in run or watch mode."
  }, {
    "heading": "",
    "content": "Override the default port (9789) used for the SSO login callback server\nduring authentication."
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "¥Environment variables in tasks"
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "Turborepo 将在任务执行期间提供以下环境变量："
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "¥Turborepo will make the following environment variables available within your tasks while they are executing:"
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "变量"
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "描述"
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "TURBO_HASH"
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "当前正在运行的任务的哈希值。"
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "TURBO_IS_TUI"
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "使用 TUI 时，此变量设置为 true。"
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "TURBO_IS_MFE"
  }, {
    "heading": "任务中的环境变量-environment-variables-in-tasks",
    "content": "使用 microfrontends 时，此变量设置为应用在 microfrontends.json 中定义的端口。"
  }],
  "headings": [{
    "id": "任务中的环境变量-environment-variables-in-tasks",
    "content": "任务中的环境变量 /*environment-variables-in-tasks*/"
  }]
};
import {Heading} from 'fumadocs-ui/components/heading';
export const toc = [{
  depth: 2,
  url: "#任务中的环境变量-environment-variables-in-tasks",
  title: _jsx(_Fragment, {
    children: "任务中的环境变量 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "通过设置某些环境变量，你可以更改 Turborepo 的行为。这对于为不同的环境和机器创建特定的配置非常有用。"
    }), "\n", _jsx(_components.p, {
      children: "¥By setting certain environment variables, you can change Turborepo's behavior. This can be useful for creating specific configurations for different environments and machines."
    }), "\n", _jsxs(_components.p, {
      children: ["系统环境变量始终会被直接提供给 ", _jsx(_components.code, {
        children: "turbo"
      }), " 命令的标志值覆盖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥System environment variables are always overridden by flag values provided directly to your ", _jsx(_components.code, {
        children: "turbo"
      }), " commands."]
    }), "\n", _jsxs("table", {
      id: "system-environment-variables-table",
      children: [_jsx("thead", {
        children: _jsxs("tr", {
          children: [_jsx("th", {
            children: "Variable"
          }), _jsx("th", {
            children: "Description"
          })]
        })
      }), _jsxs("tbody", {
        children: [_jsxs("tr", {
          id: "force_color",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "FORCE_COLOR"
            })
          }), _jsx("td", {
            children: "Forces color to be shown in terminal logs"
          })]
        }), _jsxs("tr", {
          id: "turbo_api",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_API"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Set the base URL for", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_binary_path",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: _jsx("code", {
                children: "TURBO_BINARY_PATH"
              })
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Manually set the path to the ", _jsx("code", {
                children: "turbo"
              }), " binary. By default,", ' ', "\n", _jsx("code", {
                children: "turbo"
              }), " will automatically discover the binary so you should\nonly use this in rare circumstances."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_cache",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: _jsx("code", {
                children: "TURBO_CACHE"
              })
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["Control reading and writing for cache sources. Uses the same syntax as", ' ']
            }), _jsxs("a", {
              href: "/docs/reference/run#--cache-options",
              children: [' ', _jsx("code", {
                children: "--cache"
              })]
            }), _jsx(_components.p, {
              children: "."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_cache_dir",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_CACHE_DIR"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["Sets the cache directory, similar to using", ' ']
            }), _jsxs("a", {
              href: "/docs/reference/run#--cache-dir-path",
              children: [' ', _jsx("code", {
                children: "--cache-dir"
              })]
            }), ' ', _jsx(_components.p, {
              children: "flag."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_ci_vendor_env_key",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_CI_VENDOR_ENV_KEY"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Set a prefix for environment variables that you want\n", _jsx("strong", {
                children: "excluded"
              }), " from ", _jsx("a", {
                href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
                children: "\nFramework Inference\n"
              }), ".", _jsx("span", {}), "\n", _jsx("strong", {
                children: "NOTE"
              }), ": This does not need to be set by the user and should\nbe configured automatically by supported platforms."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_dangerously_disable_package_manager_check",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["Disable checking the ", _jsx("code", {
                children: "packageManager"
              }), " field in", ' ', "\n", _jsx("code", {
                children: "package.json"
              }), ". You may run into", ' ']
            }), _jsx("a", {
              href: "/docs/reference/run#--dangerously-disable-package-manager-check",
              children: _jsx(_components.p, {
                children: "errors and unexpected caching behavior"
              })
            }), ' ', _jsxs(_components.p, {
              children: ["when disabling this check. Use ", _jsx("code", {
                children: "true"
              }), " or ", _jsx("code", {
                children: "1"
              }), " to\ndisable."]
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_download_local_enabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_DOWNLOAD_LOCAL_ENABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Enables global ", _jsx("code", {
                children: "turbo"
              }), " to install the correct local version\nif one is not found."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_force",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_FORCE"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Set to ", _jsx("code", {
                children: "true"
              }), " to force all tasks to run in full, opting out\nof all caching."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_global_warning_disabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_GLOBAL_WARNING_DISABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Disable warning when global ", _jsx("code", {
                children: "turbo"
              }), " cannot find a local\nversion to use."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_print_version_disabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_PRINT_VERSION_DISABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Disable printing the version of ", _jsx("code", {
                children: "turbo"
              }), " that is being\nexecuted."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_log_order",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_LOG_ORDER"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Set the ", _jsx("a", {
                href: "/docs/reference/run#--log-order-option",
                children: "log order"
              }), ".\nAllowed values are ", _jsx("code", {
                children: "grouped"
              }), " and ", _jsx("code", {
                children: "default"
              }), "."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_login",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_LOGIN"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Set the URL used to log in to", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), ". Only\nneeded for self-hosted Remote Caches that implement an endpoint that\ndynamically creates tokens."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_no_update_notifier",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_NO_UPDATE_NOTIFIER"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Remove the update notifier that appears when a new version of", ' ', "\n", _jsx("code", {
                children: "turbo"
              }), " is available. You can also use", ' ', "\n", _jsx("code", {
                children: "NO_UPDATE_NOTIFIER"
              }), " per ecosystem convention."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_platform_env",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_PLATFORM_ENV"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["A CSV of environment variable keys that are configured in a supported CI\nenvironment (Vercel). ", _jsx("strong", {
                children: "NOTE"
              }), ": This variable is meant for\nplatforms looking to implement zero-configuration environment variables.\nYou are not meant to use this variable as an end user.", ' ']
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_platform_env_disabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_PLATFORM_ENV_DISABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Disable checking environment variables configured in your", ' ', "\n", _jsx("code", {
                children: "turbo.json"
              }), " against those set on your supported platform"]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_preflight",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_PREFLIGHT"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Enables sending a preflight request before every cache artifact and\nanalytics request. The follow-up upload and download will follow\nredirects. Only applicable when", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Caching"
              }), " is\nconfigured."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_cache_read_only",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_CACHE_READ_ONLY"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Prevent writing to the", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), " - but\nstill allow reading."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_cache_signature_key",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["Sign artifacts with a secret key. For more information, visit", ' ']
            }), _jsx("a", {
              href: "/docs/core-concepts/remote-caching#artifact-integrity-and-authenticity-verification",
              children: _jsx(_components.p, {
                children: "the Artifact Integrity section"
              })
            }), _jsx(_components.p, {
              children: "."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_cache_timeout",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_CACHE_TIMEOUT"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Set a timeout in seconds for ", _jsx("code", {
                children: "turbo"
              }), " to get artifacts from", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_cache_upload_timeout",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_CACHE_UPLOAD_TIMEOUT"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Set a timeout in seconds for ", _jsx("code", {
                children: "turbo"
              }), " to upload artifacts to", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_remote_only",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_REMOTE_ONLY"
            })
          }), _jsx("td", {
            children: "Always ignore the local filesystem cache for all tasks."
          })]
        }), _jsxs("tr", {
          id: "turbo_run_summary",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_RUN_SUMMARY"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Generate a ", _jsx("a", {
                href: "/docs/reference/run#--summarize",
                children: "Run Summary"
              }), ' ', "\nwhen you run tasks."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_scm_base",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_SCM_BASE"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Base used by ", _jsx("code", {
                children: "--affected"
              }), " when calculating what has changed\nfrom ", _jsx("code", {
                children: "base...head"
              })]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_scm_head",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_SCM_HEAD"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Head used by ", _jsx("code", {
                children: "--affected"
              }), " when calculating what has changed\nfrom ", _jsx("code", {
                children: "base...head"
              })]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_team",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_TEAM"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["The account name associated with your repository. When using", ' ']
            }), _jsx("a", {
              href: "https://vercel.com/docs/monorepos/remote-caching#vercel-remote-cache",
              rel: "noreferrer noopener",
              target: "_blank",
              children: _jsx(_components.p, {
                children: "Vercel Remote Cache"
              })
            }), _jsxs(_components.p, {
              children: [", this is ", _jsx(_components.a, {
                href: "https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fsettings&title=Get+team+slug",
                children: "your team's slug"
              }), "."]
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_teamid",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_TEAMID"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["The account identifier associated with your repository. When using", ' ']
            }), _jsx("a", {
              href: "https://vercel.com/docs/monorepos/remote-caching#vercel-remote-cache",
              rel: "noreferrer noopener",
              target: "_blank",
              children: _jsx(_components.p, {
                children: "Vercel Remote Cache"
              })
            }), _jsx(_components.p, {
              children: ", this is your team's ID."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_telemetry_message_disabled",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_TELEMETRY_MESSAGE_DISABLED"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["Disable the message notifying you that", ' ', "\n", _jsx("a", {
                href: "/docs/telemetry",
                children: "Telemetry"
              }), " is enabled."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_token",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_TOKEN"
            })
          }), _jsx("td", {
            children: _jsxs(_components.p, {
              children: ["The Bearer token for authentication to access", ' ', "\n", _jsx("a", {
                href: "/docs/core-concepts/remote-caching",
                children: "Remote Cache"
              }), "."]
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_ui",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_UI"
            })
          }), _jsx("td", {
            children: _jsx(_components.p, {
              children: "Enables TUI when passed true or 1, disables when passed false or 0."
            })
          })]
        }), _jsxs("tr", {
          id: "turbo_concurrency",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_CONCURRENCY"
            })
          }), _jsxs("td", {
            children: [_jsxs(_components.p, {
              children: ["Controls", ' ']
            }), _jsx("a", {
              href: "/repo/docs/reference/run#--concurrency-number--percentage",
              children: _jsx(_components.p, {
                children: "concurrency"
              })
            }), ' ', _jsx(_components.p, {
              children: "settings in run or watch mode."
            })]
          })]
        }), _jsxs("tr", {
          id: "turbo_sso_login_callback_port",
          children: [_jsx("td", {
            children: _jsx("code", {
              children: "TURBO_SSO_LOGIN_CALLBACK_PORT"
            })
          }), _jsx("td", {
            children: _jsx(_components.p, {
              children: "Override the default port (9789) used for the SSO login callback server\nduring authentication."
            })
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "任务中的环境变量-environment-variables-in-tasks",
      children: "任务中的环境变量 "
    }), "\n", _jsx(_components.p, {
      children: "¥Environment variables in tasks"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 将在任务执行期间提供以下环境变量："
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo will make the following environment variables available within your tasks while they are executing:"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "变量"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_HASH"
            })
          }), _jsx(_components.td, {
            children: "当前正在运行的任务的哈希值。"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_IS_TUI"
            })
          }), _jsxs(_components.td, {
            children: ["使用 ", _jsx(_components.a, {
              href: "/docs/reference/configuration#ui",
              children: "TUI"
            }), " 时，此变量设置为 ", _jsx(_components.code, {
              children: "true"
            }), "。"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_IS_MFE"
            })
          }), _jsxs(_components.td, {
            children: ["使用 ", _jsx(_components.a, {
              href: "/docs/guides/microfrontends",
              children: "microfrontends"
            }), " 时，此变量设置为应用在 ", _jsx(_components.code, {
              children: "microfrontends.json"
            }), " 中定义的端口。"]
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
